import { Button, ButtonGroup } from "@nextui-org/button";
import { ButtonGroupProps, ButtonProps } from "@nextui-org/react";

const ZButton = ({ children, type = "button", ...props }: ButtonProps) => {
  return (
    <Button
      color={props.color || "primary"}
      radius="sm"
      type={type}
      {...props}
      isLoading={false}
    >
      {children}
    </Button>
  );
};

const ZButtonGroup = ({ children, ...props }: ButtonGroupProps) => {
  return <ButtonGroup {...props}>{children}</ButtonGroup>;
};

export { ZButton, ZButtonGroup };
